import { gql } from '@provision/graphql-client';

export const CREATE_DRAFT_WORKFLOW_VERSION_MUTATION = gql`
  mutation CreateDraftWorkflowVersion($input: CreateDraftWorkflowVersionInput!) {
    createDraftWorkflowVersion(input: $input) {
      workflowId
      workflowVersionId
      version
    }
  }
`;

export const CHANGE_WORKFLOW_VERSION_ACTIVE_STATE_MUTATION = gql`
  mutation ChangeWorkflowVersionActiveState($input: ChangeWorkflowVersionActiveStateInput!) {
    changeWorkflowVersionActiveState(input: $input) {
      workflowId
      workflowVersionId
      active
    }
  }
`;

export const SOFT_DELETE_WORKFLOW_VERSION_MUTATION = gql`
  mutation SoftDeleteWorkflowVersion($input: SoftDeleteWorkflowVersionInput!) {
    softDeleteWorkflowVersion(input: $input)
  }
`;
